import summary1 from "./summary1.jst";
import summary2 from "./summary2.jst";
import summary3 from "./summary3.jst";
import summary4 from "./summary4.jst";

const defaultTemplate = "summary2";

const templates = {
    summary1: {
        template: summary1,
        description: "Calculated Value with label with supporting values and labels"
    },
    summary2: {
        template: summary2,
        description: "Calculated Value with supporting values and labels"
    },
    summary3: {
        template: summary3,
        description: "Two values and labels"
    },
    summary4: {
        template: summary4,
        description: "Two values and labels"
    }
};

export const getTemplate = (key = defaultTemplate) => templates[key].template;
